import { render, staticRenderFns } from "./schoolExpertFoto.vue?vue&type=template&id=5d5fee84"
import script from "./schoolExpertFoto.vue?vue&type=script&lang=js"
export * from "./schoolExpertFoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports